import React from 'react';
import '../styles/PageIndicator.css';
import { MobileStepper } from '@mui/material';
import Logo from '../assets/ProInsight-Logo.png';


export default function PageIndicator({currentPage, steps}) {
    return (
        <header className="page-indicator">
            {
                currentPage === -1
                ?
                    <img src={Logo} alt="logo" />
                :
                    <MobileStepper
                    className='stepper'
                    variant="dots"
                    steps={steps}
                    position="static"
                    activeStep={currentPage || 100}
                    sx={{ flexGrow: 1 }}
                    />
            }

        </header>
    )
}